import React from "react";
import { AttendanceManagement } from "./list";

const ProjectTeamAttendancesPage: React.FC = () => {
  return (
    <AttendanceManagement
      showTabs={false}
      initialTab="project"
      defaultViewMode="matrix"
    />
  );
};

export default ProjectTeamAttendancesPage;
